import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import TextInput from '../../../components/UI/Form/Text/Text';
import PasswordInput from '../../../components/UI/Form/Password/Password';
import Select from '../../../components/UI/Form/Select/Select';
import Button from '../../../components/UI/Button/Button';
import * as actions from '../../../store/actions/index';
import appContext from '../../../context/App';
import { AuthLocalStorage } from "../../../shared/classes";

export const UnconnectedLogin = props => {
    const authLocalStorage = new AuthLocalStorage();
    const [headerTitle, setHeaderTitle] = appContext.useAppContext();

    useEffect(() => {
        setHeaderTitle('MSDO Live');
    }, [setHeaderTitle]);

    const submitHandler = (values) => {
        props.onAuth(values.username + '@wm.com', values.password, values.region);
    };

    const regions = [
        {
            label: 'USA',
            value: 'USA'
        },
        {
            label: 'Canada',
            value: 'Canada'
        }
    ]

    return (
        <>
            <Formik
                initialValues={{
                    region: authLocalStorage.authRegion || '',
                    username: (authLocalStorage.authUserName && authLocalStorage.authUserName.replace('@wm.com', '')) || '',
                    password: ''
                }}
                validationSchema={Yup.object({
                    region: Yup.string()
                        .required('Required'),
                    username: Yup.string()
                        .matches(/^(?!.*@wm.com).*$/, { message: "Please don't provide @wm.com in the username " })
                        .required('Required'),
                    password: Yup.string()
                        .required('Required')
                })}
                onSubmit={submitHandler}
            >
                <Form data-test="login-form" autoComplete="on">
                    <Select
                        data-test="region"
                        label="Region*"
                        name="region"
                        options={regions} />

                    <TextInput
                        data-test="username"
                        label="Username*"
                        name="username" />

                    <PasswordInput
                        data-test="password"
                        label="Password*"
                        name="password" />

                    {props.error ? <Typography color="error" variant="body1" data-test="error-message">{props.error}</Typography> : null}

                    {props.loading ? <div className="text-center" data-test="progress-loader"><CircularProgress /></div> : null}

                    <Button size="large" variant="contained" color="default" className="btn-block rounded-0 my-3 info-btn" type="submit" disabled={props.loading} data-test="login-button">LOGIN</Button>
                </Form>
            </Formik>
        </>
    )
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, password, region) => dispatch(actions.auth(username, password, region))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedLogin);